import React from 'react'

import Utilities from '../../utils/Utilities'
import Party from '../../models/Party'

import './HeaderResults.scss'
import { LIGHT_CHECK } from '../../utils/Constants'
import { IResultKeysProps, mapResultKeysToProps } from '../../utils/ReduxStore'
import { resultForKey } from '../../controllers/DataController'
import { connect } from 'react-redux'

interface IProps extends IResultKeysProps {}

class HeaderResults extends React.Component<IProps> {
  public render(): JSX.Element {
    const nationalResult = resultForKey(this.props.compareResultKey)
    const baseNationalResult = resultForKey(this.props.baseResultKey)

    const seatCells = Party.allPartiesArray().map(
      (party): JSX.Element => {
        const result = nationalResult.partyResultByParty(party)
        const result2015 = baseNationalResult.partyResultByParty(party)
        if (result && result2015) {
          const outcome = result.outcome
          const showOutcome =
            outcome === 'majority' || outcome === 'minority' ? (
              <div className="Outcome">
                <span className="d-none d-sm-block">
                  <span className="Text">{outcome}</span>
                  <br />
                  <span className="Check">{LIGHT_CHECK}</span>
                </span>
                <span className="d-sm-none">
                  <span className="Text">
                    {outcome.substr(0, 3)}. {LIGHT_CHECK}
                  </span>
                </span>
              </div>
            ) : outcome === 'opposition' ? (
              <div className="Outcome">
                <span className="Text d-lg-none">{outcome.substr(0, 3)}.</span>
                <span className="Text d-none d-lg-inline">{outcome}</span>
              </div>
            ) : outcome === 'tie' ? (
              <div className="Outcome">
                <span className="d-none d-sm-block">
                  <span className="Text">{outcome}!</span>
                  <br />
                  <span className="Check">=</span>
                </span>
                <span className="d-sm-none">
                  <span className="Text">{outcome}! =</span>
                </span>
              </div>
            ) : (
              <div />
            )
          return (
            <div key={party.key} className={`col`}>
              <div className={`py-1 px-1 px-sm-2 party-${party.key}-bg`}>
                <div className="PartyKey my-0">{party.key}</div>
                <div className="VotePercent d-none d-sm-block my-0">
                  {Utilities.formatPercent(result.votePercent)}
                  {/* <small className={`Change party-${party.key}-lighter`}>
                    {Utilities.formatPercentDiff(
                      result2015.votePercent,
                      result.votePercent
                    )}
                  </small> */}
                </div>
                <div className="SeatCount my-0">
                  {result.seatCount}
                  {/* <small className={`Change party-${party.key}-lighter`}>
                    {Utilities.formatDiff(
                      result2015.seatCount,
                      result.seatCount
                    )}
                  </small> */}
                </div>
                <small>{showOutcome}</small>
              </div>
            </div>
          )
        } else {
          return (
            <div key={party.key} className={`col`}>
              <div className={`py-1 px-1 px-sm-2 party-${party.key}-bg`}>
                <div className="PartyKey my-0">{party.key}</div>
                <div className="VotePercent d-none d-sm-block my-0">
                  {Utilities.formatPercent(0)}
                  {/* <small className={`Change party-${party.key}-lighter`}>
                {Utilities.formatPercentDiff(
                  result2015.votePercent,
                  result.votePercent
                )}
              </small> */}
                </div>
                <div className="SeatCount my-0">
                  {0}
                  {/* <small className={`Change party-${party.key}-lighter`}>
                {Utilities.formatDiff(
                  result2015.seatCount,
                  result.seatCount
                )}
              </small> */}
                </div>
              </div>
            </div>
          )
        }
      }
    )

    return (
      <div className="HeaderResults row no-gutters">
        {seatCells}
        {/* <div className={`col-12 font-weight-bold party-${winner.party.key}`}>
          <h1>
            {nationalResult.winner().party.shortName} {winner.outcome}
          </h1>
        </div> */}
      </div>
    )
  }
}

export default connect(mapResultKeysToProps)(HeaderResults)
